import { MButtonType } from '../MButton/MButton.types';

export enum MContentHeaderAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export type MContentHeaderAllowedButtonType = MButtonType.Secondary | MButtonType.Tertiary;

export interface MContentHeaderEyebrow {
  eyebrowText?: string;
}

export interface MContentHeaderHeader {
  size?: string;
  text?: string;
  headerTag?: string;
}

export interface MContentHeaderBody {
  bodyText?: string;
  color?: string;
  size?: string;
}

export interface MContentHeaderTextBlock {
  alignment?: string;
  aEyebrow?: MContentHeaderEyebrow;
  aHeader?: MContentHeaderHeader;
  aBody?: MContentHeaderBody;
}

export interface MContentHeaderIcon {
  size?: string;
  icon?: string;
}

export interface MContentHeaderButton {
  buttonText?: string;
  buttonType?: MContentHeaderAllowedButtonType;
  /** @deprecated AEM legacy name for buttonType */
  type?: string;
  size?: string;
  icon?: string;
  openInANewTab?: boolean | string;
  externalLink?: boolean;
  ctaLink?: string;
  aIcon?: MContentHeaderIcon;
}

export interface MContentHeaderItem {
  alignment?: MContentHeaderAlignment;
  cta?: 'true' | 'false';
  secondaryCta?: 'true' | 'false';
  mTextBlockSimple?: MContentHeaderTextBlock;
  mButton?: MContentHeaderButton;
  mButton2?: MContentHeaderButton;
}

export interface MContentHeaderProps extends MContentHeaderItem {
  /** @deprecated Use flat props (`alignment`, `mTextBlockSimple`, `cta`, `mButton`, `secondaryCta`, `mButton2`) directly instead. This wrapper will be removed in a future release. */
  mContentHeader?: MContentHeaderItem;
}
